<template>
  <div>
    <div class="body1">{{ $t("modals.applyGlobalPolicyConfirmation.description") }}</div>
    <ul class="ml-4 mt-3">
      <li v-for="item in workspacesWithPolicies" :key="item">
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import cloneDeep from "lodash/cloneDeep";
import { computed, defineComponent, onMounted, type PropType, ref } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module";
import type { GlobalPolicyWorkspaceToAssign } from "@/_store/msp/global-policies/msp-global-policies.module.ts";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  emits: ["update:localValue"],
  setup(props, { emit }) {
    const localValue = ref({});

    const workspacesWithPolicies = computed(() => {
      return props.config.item.workspaces
        .filter((workspace: GlobalPolicyWorkspaceToAssign) => {
          return !!workspace.mspPolicyName;
        })
        .map((w: GlobalPolicyWorkspaceToAssign) => w.displayName);
    });

    onMounted(() => {
      localValue.value = cloneDeep(props.config.item);
      emit("update:localValue", localValue.value);
    });

    return {
      workspacesWithPolicies,
    };
  },
});
</script>

<style lang="scss" scoped>
.checkbox-description {
  color: rgb(var(--v-theme-indigo-medium));
}
</style>
